import axios from "axios";

const path = "/collection-index-config";

export const indexConfigService = {
  async list(filter = {}) {
    return await axios.get(path, { params: filter });
  },

  async createJob(chainId, address, isCollectionExternal) {
    return await axios.post(`${path}/${address}/${chainId}`, { isCollectionExternal });
  },

  async toggleLive(chainId, address) {
    return await axios.post(`${path}/auto-index/${address}/${chainId}`);
  },

  async delete(chainId, address) {
    return await axios.delete(`${path}/${address}/${chainId}`);
  },

  async fix(chainId, address) {
    return await axios.patch(`${path}/fix-missing/${address}/${chainId}`);
  },

  async createJobSyncIndexMetadata(chainId, address) {
    return await axios.post(`${path}/refresh-metadata/${address}/${chainId}`);
  },
};
